import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
export const AppTitle = t0 => {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Head><title>Swift: {title}</title></Head>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};